import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MapSearch } from '../models/map.search';
import { MapComponent } from '../map.component';

@Component({
  selector: 'movisat-map-search',
  templateUrl: './map-search.component.html',
  styleUrls: ['./map-search.component.css']
})
export class MapSearchComponent implements OnInit, AfterViewInit {
  @Input()
  provider = ''; // Proveedor por defecto
  @Input()
  lang = ''; // Idioma por defecto
  @Input()
  searchCountry = ''; // Pais por defecto a efectos de búsquedas
  @Input()
  texts = new Map<string, string>(); // Textos del idioma cargado
  @Input()
  searchBounds = ''; // Marco geográfico a efectos de búsquedas
  @Output()
  mapSearch = new EventEmitter<MapSearch>();

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      // Si no se han definido parámetros cojo los del primer mapa que se haya creado
      if (this.provider.length < 1) {
        this.provider = MapComponent.provider ? MapComponent.provider : 'Google';
      }
      if (this.lang.length < 1) {
        this.lang = MapComponent.lang ? MapComponent.lang : 'es-ES';
      }
      if (this.searchCountry.length < 1) {
        this.searchCountry = MapComponent.searchCountry ? MapComponent.searchCountry : 'es';
      }
      if (this.texts.size < 1) {
        this.texts = MapComponent.texts ? MapComponent.texts : new Map<string, string>();
      }
      if (this.searchBounds.length < 1) {
        this.searchBounds = MapComponent.searchBounds ? MapComponent.searchBounds : '';
      }
    });
  }

  // Cuando se realiza una búsqueda en el mapa
  onMapSearch(search: MapSearch) {
    this.mapSearch.emit(search);
  }

}
